export default "64e3de3b0ffcb50e.svg"